import {
  B2BPaymentRequestRepresentations,
  PaymentRequestRepresentation,
  PaymentRequestRepresentations,
} from '@assets/language/PaymentRequestRepresentation';
import { Currency } from './CurrencyCode';
import { Language } from './Language';
import { Market } from './Market';
import { PaymentRequestStatus } from '@core/params';
import { LineItem } from './paymentRequest/paymentRequest';

export interface B2bPaymentData {
  buyerEmail: string;
  dueDate: Date;
  nin: string;
  status: string;
  buyerCompanyName: string;
  invoiceReference: string;
}

export enum ProductPaymentMethod {
  SWISH = 'SWISH',
  VIPPS = 'VIPPS',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
  BANK_TRANSFER = 'BANK_TRANSFER',
  PAY_LATER = 'PAY_LATER',
  INSTALLMENTS = 'INSTALLMENTS',
  INSTANT_DIRECT_DEBIT = 'INSTANT_DIRECT_DEBIT', // this is ZID, in case that is not clear
  DIRECT_DEBIT_NO_GUARANTEE = 'DIRECT_DEBIT_NO_GUARANTEE',
  MONTHLY_INVOICE = 'MONTHLY_INVOICE',
  B2B_R2P = 'B2B_R2P', // "Request to pay" a.k.a. "Betalinstruktion"
  B2B_PAY_LATER = 'B2B_PAY_LATER',
  B2B_INSTALLMENTS = 'B2B_INSTALLMENTS',
  ACCOUNT_RECEIVABLE_FINANCING_INVOICE = 'ACCOUNT_RECEIVABLE_FINANCING_INVOICE',
  ACCOUNT_RECEIVABLE_FINANCING_INVOICE_CONVERTIBLE = 'ACCOUNT_RECEIVABLE_FINANCING_INVOICE_CONVERTIBLE',
  ACCOUNT_RECEIVABLE_FINANCING_ANNUITY = 'ACCOUNT_RECEIVABLE_FINANCING_ANNUITY',
  ACCOUNT_RECEIVABLE_FINANCING_B2B_ANNUITY = 'ACCOUNT_RECEIVABLE_FINANCING_B2B_ANNUITY',
  ACCOUNT_RECEIVABLE_FINANCING_FINANCIAL_LEASING = 'ACCOUNT_RECEIVABLE_FINANCING_FINANCIAL_LEASING',
  INSTALLMENTS_STATIC_AMOUNT = 'INSTALLMENTS_STATIC_AMOUNT',
  PAY_IN_ADVANCE = 'PAY_IN_ADVANCE',
  OTHER = 'OTHER',
}

export class PaymentRequestResponse {
  title: string;
  description: string;
  value: Currency;

  market: Market;
  language: Language;
  phone: string;
  email: string;

  id: string;
  created: Date;
  dateDisplay: string;
  status: PaymentRequestStatus;
  statusText: string;
  statusColor: string;
  backgroundColor: string;
  checkoutLink: string;
  completedAt: Date;
  cancelledAt: Date;
  latestCaptureTimeStamp: Date;
  buyerName: string;
  price: number;
  buyerType: 'CONSUMER' | 'COMPANY';
  b2bPaymentData: B2bPaymentData;
  paymentMethod: ProductPaymentMethod;
  buyerEmail: string;
  buyerCityAddress: string;
  buyerZipAddress: string;
  buyerStreetAddress: string;
  buyerCountry: string;
  buyerBirthDate: Date;
  capturedAmount: Currency;
  representativeName: string;
  representativeEmail: string;
  storeName: string;
  pendingRefundableValue: number;
  hideInstallmentOptions?: boolean;
  lineItems: LineItem[];
  expiryDate: Date;
  settledLoanOfferId: string;
  merchantReference: string;

  to;

  refundedValue: Currency;
  refundableValue: Currency;

  static setup(paymentRequestResponse: PaymentRequestResponse) {
    if (paymentRequestResponse.status === 'PENDING_BUYER_REGISTRATION') {
      paymentRequestResponse.to = paymentRequestResponse.phone;
    } else {
      paymentRequestResponse.to = paymentRequestResponse.buyerName;
    }
    let statusInfo: PaymentRequestRepresentation;
    if (
      paymentRequestResponse.status === PaymentRequestStatus.OPEN_REFUND ||
      paymentRequestResponse.status === PaymentRequestStatus.PARTLY_REFUNDED ||
      paymentRequestResponse.status === PaymentRequestStatus.FULLY_REFUNDED
    ) {
      statusInfo = PaymentRequestRepresentations.get(
        paymentRequestResponse.status
      );
    } else if (paymentRequestResponse.buyerType === 'COMPANY') {
      statusInfo = B2BPaymentRequestRepresentations.get(
        paymentRequestResponse.b2bPaymentData.status
      );
    } else {
      statusInfo = PaymentRequestRepresentations.get(
        paymentRequestResponse.status
      );
    }
    if (!statusInfo) {
      statusInfo = PaymentRequestRepresentations.get('_default_');
    }
    if (
      paymentRequestResponse.status === 'PENDING_MERCHANT_SIGN_OFF' &&
      paymentRequestResponse.capturedAmount &&
      paymentRequestResponse.capturedAmount.amount <
        paymentRequestResponse.price &&
      paymentRequestResponse.capturedAmount.amount > 0
    ) {
      statusInfo = PaymentRequestRepresentations.get('PARTIALLY_CAPTURED');
    }

    paymentRequestResponse.statusText = statusInfo.friendlyStatus;
    paymentRequestResponse.statusColor = statusInfo.textColor;
    paymentRequestResponse.backgroundColor = statusInfo.backgroundColor;
  }
}
